<template>
  <div
    class="comp-container"
    :class="{
      'comp-container__h5': isH5,
      'comp-container__landscape': isLandscape,
    }"
  >
    <div class="current-time time">
      <span>{{ formatTime(currentTime) }}</span
      ><span v-if="isH5"> / {{ formatTime(initDuration) }}</span>
    </div>
    <div class="draggable-progress-bar">
      <div class="progress-track">
        <div
          class="progress"
          :style="{ width: `${displayProgress * 100}%` }"
        ></div>
      </div>
      <input
        v-if="initDuration"
        ref="range"
        class="range"
        type="range"
        min="0"
        step="0.000001"
        max="100"
        :value="displayProgress * 100"
        @input="inputValue"
        @change="changeValue"
        @mousedown="touchstart"
        @mouseup="touchend"
        @touchstart="touchstart"
        @touchmove="inputValue"
        @touchend="touchend"
        @keydown="keydown"
      />
    </div>
    <div v-if="!isH5" class="total-time time">
      {{ formatTime(initDuration) }}
    </div>
  </div>
</template>

<script>
import { isMobile } from "@saas/components/src";
export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    initCurrentTime: {
      type: Number,
      default: 0,
    },
    initDuration: {
      type: Number,
      default: 0,
    },
    isLandscape: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value: {
      handler(newValue) {
        if (this.isDragging) {
          return;
        }
        this.setDisplayProgress(newValue);
      },
      immediate: true, // 初始化时同步设置 currentProgress
    },
    initCurrentTime: {
      handler(newValue) {
        if (this.isDragging) return;
        this.displayTime = Number(newValue) || 0;
      },
      immediate: true, // 初始化时同步设置 currentProgress
    },
  },
  data() {
    return {
      displayProgress: 0,
      displayTime: 0,
      isH5: isMobile(),
      isDragging: false,
      lastCommittedProgress: null,
    };
  },
  mounted() {},
  computed: {
    currentProgress() {
      return this.displayProgress;
    },
    currentTime() {
      return this.displayTime;
    },
  },
  methods: {
    normalizeProgress(value) {
      const progress = Number(value) || 0;
      return Math.max(0, Math.min(progress, 1));
    },
    getEventProgress(e) {
      const value = e?.target?.value ?? this.$refs.range?.value ?? 0;
      return this.normalizeProgress(value / 100);
    },
    setDisplayProgress(value) {
      this.displayProgress = this.normalizeProgress(value);
      this.displayTime = this.displayProgress * this.initDuration;
    },
    touchend(e) {
      this.commitValue(e);
      this.isDragging = false;
    },
    touchstart() {
      this.isDragging = true;
    },
    inputValue(e) {
      this.setDisplayProgress(this.getEventProgress(e));
    },
    changeValue(e) {
      this.commitValue(e);
    },
    commitValue(e) {
      const progress = this.getEventProgress(e);
      this.setDisplayProgress(progress);
      if (this.lastCommittedProgress === progress) {
        return;
      }
      this.lastCommittedProgress = progress;
      this.$emit("change", progress);
    },
    // 格式化时间 00:00:00 ，不够小时不显示
    formatTime(seconds) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = Math.floor(seconds % 60);
      return `${hours < 10 ? "0" + hours : hours}:${
        minutes < 10 ? "0" + minutes : minutes
      }:${secs < 10 ? "0" + secs : secs}`;
    },
    keydown(e) {
      e.preventDefault();
    },
    // 判断是否手机端并且横屏
    // isLandscape() {
    //   if (isMobile()) {
    //     return window.innerWidth > window.innerHeight;
    //   } else {
    //     return false;
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
.comp-container {
  --progress-track-height: 4px;
  --progress-track-radius: 2px;
  --progress-thumb-size: 20px;
  --progress-hit-height: 20px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  .time {
    color: #fff;
    font-size: 20px;
    line-height: 28px;
  }
  .draggable-progress-bar {
    margin: 0 16px;
    flex: 1;
    position: relative;
    width: 100%;
    height: var(--progress-track-height);
    padding: 0 calc(var(--progress-thumb-size) / 2);
    background: transparent;
    border-radius: var(--progress-track-radius);
    box-sizing: border-box;
    .progress-track {
      position: absolute;
      left: calc(var(--progress-thumb-size) / 2);
      top: 0;
      width: calc(100% - var(--progress-thumb-size));
      height: 100%;
      background: rgba(217, 217, 217, 0.4);
      border-radius: var(--progress-track-radius);
      overflow: hidden;
    }
    .progress {
      position: absolute;
      height: 100%;
      background: linear-gradient(136deg, #00eb81 0%, #00c89d 100%);
      border-radius: var(--progress-track-radius);
    }
    .range {
      position: absolute;
      left: calc(var(--progress-thumb-size) / 2);
      width: calc(100% - var(--progress-thumb-size));
      height: var(--progress-hit-height);
      top: 50%;
      cursor: pointer;
      transform: translateY(-50%);
      margin: 0;
      padding: 0;
      background: transparent;
      appearance: none; /* 移除默认样式 */
      -webkit-appearance: none; /* 针对 WebKit 内核的浏览器 */
      &::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: var(--progress-thumb-size);
        height: var(--progress-thumb-size);
        background-color: #fff;
        border-radius: 50%;
        cursor: pointer;
      }

      &:hover::-webkit-slider-thumb {
        box-shadow: 0px 0px 10px 4px rgba(0, 200, 157, 0.28);
      }

      &:active::-webkit-slider-thumb {
        box-shadow: 0px 0px 10px 4px rgba(0, 200, 157, 0.28);
      }
    }
  }
}

.comp-container__h5 {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 0.9867rem;
  align-items: flex-start;
  justify-content: center;
  .time {
    font-size: 0.4rem;
    line-height: 0.56rem;
    height: 0.56rem;
    flex: 1;
  }
  .draggable-progress-bar {
    margin: 0;
    flex: none;
    margin-top: 0.1067rem;
    position: relative;
    width: 100%;
    --progress-track-height: 0.0533rem;
    --progress-track-radius: 0.0267rem;
    --progress-thumb-size: 0.32rem;
    --progress-hit-height: 24px;
    .range {
      &::-webkit-slider-thumb {
        box-shadow: 0px 0px 0.1333rem 0.0533rem rgba(0, 200, 157, 0.28);
      }
    }
  }
}
.comp-container__landscape {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 0.4688rem;
  align-items: flex-start;
  .time {
    font-size: 0.1875rem;
    line-height: 0.25rem;
    height: 0.25rem;
    flex: 1;
  }
  .draggable-progress-bar {
    margin: 0;
    flex: none;
    margin-top: 0.0625rem;
    position: relative;
    width: 100%;
    --progress-track-height: 0.0625rem;
    --progress-track-radius: 0.0313rem;
    --progress-thumb-size: 0.1563rem;
    --progress-hit-height: 20px;
    .range {
      &::-webkit-slider-thumb {
        box-shadow: 0px 0px 0.1333rem 0.0533rem rgba(0, 200, 157, 0.28);
      }
    }
  }
}
// ========== PAD 适配（768px ~ 1140px）：放大进度条方便触摸拖动 ==========
@media screen and (min-width: 768px) and (max-width: 1140px) {
  // --- 桌面浏览器窄窗口 ---
  .comp-container:not(.comp-container__h5):not(.comp-container__landscape) {
    .time {
      font-size: 18px;
      line-height: 28px;
    }
    .draggable-progress-bar {
      margin: 0 14px;
      --progress-track-height: 8px;
      --progress-track-radius: 4px;
      --progress-thumb-size: 28px;
      --progress-hit-height: 28px;
      .range {
        &:hover::-webkit-slider-thumb,
        &:active::-webkit-slider-thumb {
          box-shadow: 0px 0px 12px 5px rgba(0, 200, 157, 0.35);
        }
      }
    }
  }
}

// ========== PAD 及大屏 H5 变体适配（包含横向/竖向模式，覆盖 rem 为 px） ==========
// min-height: 500px 用于排除手机的横屏模式 (手机横屏 height 通常 < 450px)
@media screen and (min-width: 768px) and (min-height: 500px) {
  .comp-container__h5,
  .comp-container__landscape {
    display: flex !important;
    flex-direction: row !important;
    height: auto !important;
    align-items: center !important;
    .time {
      font-size: 16px !important;
      line-height: 28px !important;
      height: auto !important;
      flex: none !important;
    }
    .draggable-progress-bar {
      margin: 0 14px !important;
      margin-top: 0 !important;
      flex: 1 !important;
      --progress-track-height: 6px;
      --progress-track-radius: 3px;
      --progress-thumb-size: 20px;
      --progress-hit-height: 20px;
      .range {
        &::-webkit-slider-thumb {
          box-shadow: none !important;
        }
        &:hover::-webkit-slider-thumb,
        &:active::-webkit-slider-thumb {
          box-shadow: 0px 0px 10px 4px rgba(0, 200, 157, 0.28) !important;
        }
      }
    }
  }
}
input {
  outline: none;
}
</style>
